import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-container">
      <h1 className="contact-title">Contact Us</h1>

      <div className="contact-info">
        <div className="contact-item">
          <h3>Email:</h3>
          <p><a href="mailto:contact@college.com">contact@college.com</a></p>
        </div>

        <div className="contact-item">
          <h3>Phone:</h3>
          <p><a href="tel:+911234567890">+91 123 456 7890</a></p>
        </div>

        <div className="contact-item">
          <h3>Address:</h3>
          <p>GRAM VIKAS INTER COLLEGE, Khuthan, Jaunpur, Uttar Pradesh, India</p>
        </div>
      </div>

      <div className="contact-map">
        <h3>Find Us on the Map</h3>
        <iframe
          title="College Location"
          src="https://maps.google.com/maps?q=GRAM+VIKAS+INTER+COLLEGE+KHUTHAN+JAUNPUR&t=&z=15&ie=UTF8&iwloc=&output=embed"
          frameBorder="0"
          allowFullScreen=""
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
